export enum HouseInsuranceType {
  HOUSE_STANDARD = "houseStandard",
  HOUSE_SUPER = "houseSuper",
}

export enum HouseType {
  DETACHED_HOUSE = "DETACHED_HOUSE",
  UNDETACHED_HOUSE = "UNDETACHED_HOUSE",
  SEMI_DETACHED_HOUSE = "SEMI_DETACHED_HOUSE",
  SEMI_DETACHED_HOUSE_HORIZONTAL = "SEMI_DETACHED_HOUSE_HORIZONTAL",
  SEMI_DETACHED_HOUSE_WHOLE = "SEMI_DETACHED_HOUSE_WHOLE",
  AGRICULTURAL = "AGRICULTURAL",
  OTHER = "OTHER",
}

export enum RoofType {
  PITCHED = "PITCHED",
  FLAT = "FLAT",
}

export enum NotSuperReasonHouse {
  TOO_OLD_HOUSE = "oldHouse",
  OLD_HOUSE_ROOF_NOT_CHANGED = "oldHouseRoofNotChanged",
  OLD_HOUSE_WET_AREAS_NOT_RENOVATED = "oldHouseWetAreasNotRenovated",
  HAS_DAMAGE_FROM_PESTS = "pestsDamage",
  FULL_RENTAL = "fullRental",
}

export enum RentalOrUnoccupied {
  FULL_RENTAL = "fullRental",
  PARTIAL_RENTAL = "partialRental",
  NO_RENTAL = "noRental",
  UNOCCUPIED = "unoccupied",
}

export enum HouseStandard {
  NORMAL = "NORMAL",
  BETTER = "HIGH",
  LOWER = "LOWER",
  VERY_HIGH = "VERY_HIGH",
}

export enum AlternateOwnership {
  WILL_OWN = "willOwn",
  NOT_OWNED = "notOwned",
}
